import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Table from "react-bootstrap/Table";
import MathJax from "react-mathjax";

const MathTable = (props) => {
  const getHeaders = () => {
    const data = props.data.headers;
    return data.map((row, index) => {
      return (
        <th key={index} className="text-center">
          {row}
        </th>
      );
    });
  };

  const getRowsData = () => {
    const data = props.data.rows;
    return data.map((row, index) => {
      let color = "";
      if (Object.keys(row.values[1]).length === 3) {
        const continuityRisk = parseFloat(
          row.values[0].number *
            Math.pow(10, parseFloat(row.values[0].exponent))
        );
        const icaoThreshold = parseFloat(
          row.values[1].number *
            Math.pow(10, parseFloat(row.values[1].exponent))
        );
        if (continuityRisk < icaoThreshold) color = "table-success";
        if (continuityRisk === icaoThreshold) color = "table-warning";
        if (continuityRisk > icaoThreshold) color = "table-danger";
      }

      if (Object.keys(row.values[1]).length === 5) {
        const continuityRisk = parseFloat(
          row.values[0].number *
            Math.pow(10, parseFloat(row.values[0].exponent))
        );
        const icaoThreshold = parseFloat(
          row.values[1].startNumber *
            Math.pow(10, parseFloat(row.values[1].startExponent))
        );
        if (continuityRisk < icaoThreshold) color = "table-success";
        if (continuityRisk === icaoThreshold) color = "table-warning";
        if (continuityRisk > icaoThreshold) color = "table-danger";
      }

      return (
        <tr key={index} className={color}>
          <td className="text-center">{row.label}</td>
          {row.values.map((value, index) => {
            if (Object.keys(value).length === 3) {
              return (
                <td key={index} className="text-center">
                  <MathJax.Provider>
                    <MathJax.Node
                      inline
                      formula={`${value.number.toFixed(2)} \\times 10^{${
                        value.exponent
                      }} \\text{ ${value.unit}}`}
                    />
                  </MathJax.Provider>
                </td>
              );
            } else if (Object.keys(value).length === 5) {
              return (
                <td key={index} className="text-center">
                  <MathJax.Provider>
                    <MathJax.Node
                      inline
                      formula={`${value.startNumber} \\times 10^{${value.startExponent}} \\text{ to } ${value.endNumber} \\times 10^{${value.endExponent}} \\text{ ${value.unit}}`}
                    />
                  </MathJax.Provider>
                </td>
              );
            }
          })}
        </tr>
      );
    });
  };

  return (
    <>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>{getHeaders()}</tr>
        </thead>
        <tbody>{getRowsData()}</tbody>
      </Table>
    </>
  );
};

export default MathTable;
